import moment from "moment";
import "moment-timezone";

export function convertTZToLocal(date) {
  let tzString = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return moment(date).tz(tzString).format("DD-MM-YYYY HH:mm:ss");
}

export function convertTZToLocalFormat(date) {
  let tzString = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return moment(date).tz(tzString).format("DD-MM-YYYY");
}

export function convertTZToUTC(date) {
  let tzString = "UTC";
  return moment(date).tz(tzString).format("DD-MM-YYYY HH:mm:ss");
}

export function convertTZToUTCs(date) {
  let tzString = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return moment(date).tz(tzString).format("HH:mm");
}



export function convertTZToLocalCDR(date) {
  let tzString = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return moment(date).tz(tzString).format("DD-MM-YYYY HH:mm:ss");
}